(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-reviews-toggle]');
    if (!toggle) return;

    const section = toggle.closest('[data-testid="customer-reviews-section"]');
    if (!section) return;

    const cards = section.querySelectorAll('slideshow-slides > .card');
    const expanding = section.getAttribute('data-reviews-state') !== 'expanded';
    cards.forEach((card, index) => {
      if (index < 3) return;
      if (expanding) card.removeAttribute('hidden');
      else card.setAttribute('hidden', '');
    });
    section.setAttribute('data-reviews-state', expanding ? 'expanded' : 'compact');
    toggle.setAttribute('aria-expanded', String(expanding));

    const label = toggle.querySelector('[data-reviews-toggle-label]');
    if (label) label.textContent = expanding ? 'Show Fewer Reviews' : 'View More Reviews';

    if (typeof section.__syncReviewsNextArrow === 'function') {
      section.__syncReviewsNextArrow();
    }

    if (!expanding) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
